import { readTextFile } from '../utils/readJson.js'
import { createAndAddGenericElement, getClassList } from './generics.js'

const loadModalComponents = (modalChildList, parentDiv) => {
    if (!modalChildList) return
    for (let i = 0; i < modalChildList.length; ++i) {
        if(modalChildList[i].text) {
            const ellmentDiv = createAndAddGenericElement(getClassList(modalChildList[i]), "", parentDiv, modalChildList[i].text, modalChildList[i].element)
            if(modalChildList[i].setAttributes) ellmentDiv.setAttribute('data-dismiss', "modal")
        } else if (modalChildList[i].icon) {
            const parentButtonDiv = createAndAddGenericElement(getClassList(modalChildList[i]), "", parentDiv, "", modalChildList[i].element)
            if(modalChildList[i].setAttributes) parentButtonDiv.setAttribute('data-dismiss', "modal")
            createAndAddGenericElement(getClassList(modalChildList[i].icon), "", parentButtonDiv, "", modalChildList[i].icon.element)            
        } else if(modalChildList[i].textList) {
            for (let j = 0; j < modalChildList[i].textList.length; ++j) {
                createAndAddGenericElement(getClassList(modalChildList[i]), "", parentDiv, modalChildList[i].textList[j], modalChildList[i].element)
            }
        }
    }
}

const createModalComponents = (modalComponentObj, parentDiv) => {
    const modalWrapperDiv = createAndAddGenericElement(modalComponentObj.classList, "", parentDiv, "", modalComponentObj.element)
    loadModalComponents(modalComponentObj.modalHeader, modalWrapperDiv)
    loadModalComponents(modalComponentObj.modalBody, modalWrapperDiv)
    loadModalComponents(modalComponentObj.modalFooter, modalWrapperDiv)
}

const createModalLists = (modalLists, modalBodyTextObj, parentDiv) => {
    for(let i = 0; i < modalLists.length; ++i) {
        createModalComponents(modalLists[i], modalBodyTextObj, parentDiv)
    }
}

const updateModalListComponent = (modalComponent, message) => {
    for(let i = 0; i < modalComponent.length; ++i) {
        if (modalComponent[i].text) {
            modalComponent[i].text = message
        } else if (modalComponent[i].textList) {
            modalComponent[i].textList = []
            modalComponent[i].textList.push(message)
        }
    }
    return modalComponent
}

const updateModalLists = (modalList, inputMessageObj) => {
    for(let i = 0; i < modalList.length; ++i) {
        if(modalList[i].modalHeader) modalList[i].modalHeader = updateModalListComponent(modalList[i].modalHeader, inputMessageObj.heading)
        if(modalList[i].modalBody) modalList[i].modalBody = updateModalListComponent(modalList[i].modalBody, inputMessageObj.message)
    }
    return modalList
}

const updateModalData = (jsonData, inputMessageObj) => {
    if (!inputMessageObj) return jsonData
    jsonData.modalDialog.modalLists = updateModalLists(jsonData.modalDialog.modalLists, inputMessageObj)
    return jsonData
}

const createModal = (modalBodySection, modalDivId, modalJsonFile, inputMessageObj) => {
    readTextFile(modalJsonFile, function(readModalContent) {
        let modalData = JSON.parse(readModalContent)
        modalData = updateModalData(modalData, inputMessageObj)
        const modalRootDiv = createAndAddGenericElement(modalData.classList, "", modalBodySection, "", modalData.element)
        modalRootDiv.setAttribute('id', modalDivId)
        const modalDialogDiv = createAndAddGenericElement(modalData.modalDialog.classList, "", modalRootDiv, "", modalData.modalDialog.element)
        createModalLists(modalData.modalDialog.modalLists, modalDialogDiv)
    })
}
export { createModal }